import Vue from 'vue';
import Router from 'vue-router';
import VueAnalytics from 'vue-analytics';
import store from '@/store';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';
import CWOHome from './views/CWOHome.vue';
import FFCHome from './views/FFCHome.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    const infiniteScroll = [
      'services',
      'tv',
    ];
    if (infiniteScroll.includes(to.name) && from && from.name === 'episode') {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: process.env.VUE_APP_THEME === 'cwo' ? CWOHome : FFCHome,
    },
    {
      path: '/about',
      name: 'about',
    },
    {
      path: '/services',
      name: 'services',
      component: () => import(/* webpackChunkName: "services" */ './views/Services.vue'),
      props: true,
    },
    {
      path: '/tv',
      name: 'tv',
      component: () => import(/* webpackChunkName: "television" */ './views/Television.vue'),
      props: true,
    },
    {
      path: '/calendar',
      name: 'calendar',
      component: () => import(/* webpackChunkName: "television" */ './views/Calendar.vue'),
    },
    {
      path: '/believe',
      name: 'believe',
      component: () => import(/* webpackChunkName: "believe" */ './views/Believe.vue'),
    },
    {
      path: '/staff',
      name: 'staff',
      component: () => import(/* webpackChunkName: "staff" */ './views/Staff.vue'),
    },
    {
      path: '/giving',
      name: 'giving',
      component: () => import(/* webpackChunkName: "giving" */ './views/Giving.vue'),
    },
    {
      path: '/ministries',
      name: 'ministries',
      component: () => import(/* webpackChunkName: "ministries" */ './views/Ministries.vue'),
    },
    {
      path: '/ministries/:id',
      name: 'ministry',
      component: () => import(/* webpackChunkName: "ministry" */ './views/Ministry.vue'),
      props: true,
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "contact" */ './views/Contact.vue'),
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import(/* webpackChunkName: "faq" */ './views/FAQ.vue'),
    },
    {
      path: '/times',
      name: 'times',
      component: () => import(/* webpackChunkName: "times" */ './views/Times.vue'),
    },
    {
      path: '/articles',
      name: 'articles',
      component: () => import(/* webpackChunkName: "articles" */ './views/Articles.vue'),
    },
    {
      path: '/articles/:id',
      name: 'article',
      component: () => import(/* webpackChunkName: "article" */ './views/Article.vue'),
      props: true,
    },
    {
      path: '/episodes/:id',
      name: 'episode',
      component: () => import(/* webpackChunkName: "episode" */ './views/Episode.vue'),
    },
    {
      path: '/events/:id',
      name: 'event',
      component: () => import(/* webpackChunkName: "event" */ './views/Event.vue'),
    },
    {
      path: '/events/:id/thanks',
      name: 'registrationConfirmation',
      component: () => import(/* webpackChunkName: "registrationConfirmation" */ './views/RegistrationConfirmation.vue'),
      props: true,
    },
    {
      path: '/collections/:id',
      name: 'collection',
      component: () => import(/* webpackChunkName: "collection" */ './views/Collection.vue'),
    },
    {
      path: '/speakers/:id',
      name: 'speaker',
      component: () => import(/* webpackChunkName: "speaker" */ './views/Speaker.vue'),
    },
    {
      path: '/projects',
      name: 'projects',
      component: () => import(/* webpackChunkName: "projects" */ './views/Projects.vue'),
    },
  ],
});

// TODO fetch page information if necessary

router.beforeEach((to, from, next) => {
  if (store.getters[getterTypes.GET_ACCOUNT].id === undefined) {
    const host = process.env.VUE_APP_ACCOUNT_DOMAIN;
    store.dispatch(actionTypes.DO_GET_ACCOUNT, { host, zoom: 'key,location,logo,services' }).then(() => {
      next();
    });
  } else {
    next();
  }
});

router.afterEach(() => {
  store.commit(mutationTypes.SET_DRAWER, false);
});

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_ANALYTICS_ID,
    router,
  });
}
export default router;
